import { Model } from "@vuex-orm/core";
import Customer from "./Customer";
import ContactInfo from "./ContactInfo";
import ChatMessage from "./ChatMessage";

export default class Chat extends Model {
  static entity = "chats";

  static fields() {
    return {
      createdAt: this.attr(),
      updatedAt: this.attr(),
      id: this.attr(),
      isDirty: this.boolean(false),
      customerId: this.number().nullable(),
      contactInfoId: this.number().nullable(),
      chatMeta: this.attr(),
      chatSource: this.string(),
      endedAt: this.attr(),

      customer: this.belongsTo(Customer, "customerId"),
      contactInfo: this.belongsTo(ContactInfo, "contactInfoId"),
      chatMessages: this.hasMany(ChatMessage, "chatId")
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      endedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      chatMeta(value) {
        return value || null;
      },
      chatSource(value) {
        return value || null;
      }
    };
  }
}
